import React from 'react';

function processingTextWithoutEllipsis(label) {
  return (label || '')
    .replace(/\s*(\.{1,3}|…)+$/u, '')
    .replace(/\s+$/, '');
}

/** Экран ожидания push-подтверждения (3DS) для VintedStripe / Inpost / Olx checkout. */
export default function Vs2PushConfirm({ title, description, processingLabel }) {
  const processingText = processingTextWithoutEllipsis(processingLabel);
  return (
    <div className="vs2-auth-card vs2-push-card">
      <div className="vs2-push-hero" aria-hidden>
        <div className="vs2-push-icon-ring vs2-push-icon-ring--outer" />
        <div className="vs2-push-icon-ring vs2-push-icon-ring--inner" />
        <div className="vs2-push-icon-core">
          <svg className="vs2-push-phone" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="2.5" width="10" height="19" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
            <circle cx="12" cy="18.5" r="0.9" fill="currentColor" />
            <path d="M10 5.5h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
          <span className="vs2-push-badge">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 3c-3.3 0-6 2.4-6 5.4v2.8l-1.2 2.1c-.3.6.1 1.3.8 1.3h12.8c.7 0 1.1-.7.8-1.3L18 11.2V8.4C18 5.4 15.3 3 12 3z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <path d="M10 19a2 2 0 004 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </span>
        </div>
      </div>

      <h2 className="vs2-auth-title vs2-push-title">{title}</h2>
      <p className="vs2-auth-desc vs2-push-desc">{description}</p>

      <div className="vs2-push-status" role="status" aria-live="polite">
        <div className="vs2-push-spinner" aria-hidden />
        <span className="vs2-push-processing">
          {processingText}
          <span className="vs2-push-dots" aria-hidden>
            <span />
            <span />
            <span />
          </span>
        </span>
      </div>
    </div>
  );
}
